import React, { Component } from 'react';

class SimplePopover extends Component {
    isUnmounted = false
    constructor(props) {
        super(props)
        this.state = {
            content: this.props.content

        }
    }
    componentWillUnmount() {
        this.isUnmounted = true;
        // console.log('componentWillMount SimplePopover ', this);
        //  console.log(this.props.content)
    }
    componentDidMount() {

        // console.log('componentDidMount componentDidMount ', this);
        if (this.props.onLoad) {
            this.props.onLoad().then((result) => {
                if (this.isUnmounted === false) {
                    this.setState({ content: result })
                 }
                this.isUnmounted = false;
            })
        }
    }

    render() {
        return (
        <div className={(this.props.displayRight? "edb-right edb-margin edb-margin-large-right":"")+" edb-dropdown-hover adap-bg-none"} style={{ width: this.props.block ? "100%" : "auto" }}>
                {this.props.children}
                <div id={this.props.droppdownId ? this.props.droppdownId : null} className={"edb-dropdown-content edb-border edb-small adap-text-darkergray edb-bar-block"
                    + (this.props.noPadding ? "" : " edb-padding edb-margin-bottom")}
                    style={{
                        right: this.props.rightAlign ? 0 : 'inherit',
                        bottom: this.props.topAlign ? "8px" : 'inherit',
                    }}>
                    {this.state.content}
                </div>
            </div>
        );
    }
}

export default SimplePopover;